import React, {useEffect, useState} from 'react';
import {
    Paper, Table,
    TableBody, TableCell, TableContainer, TablePagination, TableRow

} from '@material-ui/core';

import {coreStyle, EnhancedTableHead} from "../../../styles/config";
import {parseQueryParams} from "../../../utils/helpers";
import Resource from "../../../crud/resource";
import Translate from "../../../utils/utils";
import {Button, InputGroup} from "react-bootstrap";
import AutoComplete from "../../../widgets/AutoComplete";
import DatePicker from "../../../widgets/DatePicker";

const headCells = [
    {id: 'inspector', label: <Translate id="TABLE.INSPECTOR"/>},
    {id: 'grower', label: <Translate id="TABLE.GROWER"/>},
    {id: 'buyer', label: <Translate id="TABLE.BUYER"/>},
    {id: 'boxes_inspected', label: <Translate id="TABLE.BOXES_INSPECTED"/>},
    {id: 'boxes_delivered', label: <Translate id="TABLE.BOXES_DELIVERED"/>}
];

export default function FlowerInspectionReportList(props) {
    const {location: {search}, history} = props;
    const queryParams = parseQueryParams(search);
    const [page, setPage] = React.useState(queryParams.page);
    const perPage = queryParams.perPage;
    const [inspections, setInspections] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [inspectors, setInspectors] = React.useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        current_page: 1,
        per_page: queryParams.perPage,
    });
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [isDownloading, setIsDownLoading] = useState(false);
    const [isDownloadComplete, setIsDownLoadComplete] = useState(false);

    useEffect(() => {
        const list = () => {
            const resource = new Resource('flowerShipment/inspection');
            setIsLoading(true);
            resource.index({
                perPage,
                page,
                inspectors,
                startDate,
                endDate,
            })
                .then(response => {
                    const {data: {data = {data: []}}} = response;
                    const paginationData = data;
                    setInspections(paginationData.data);
                    setPagination(paginationData);
                    setIsLoading(false);
                }).catch(err => {
                setIsLoading(false);
            });
        };

        list();
    }, [page, perPage, inspectors, startDate, endDate]);


    const handleChangePage = (e, page) => {
        setPage(++page);
        return history.push(`?page=${page}&perPage=${perPage}&inspectors=${inspectors}&startDate=${startDate}&endDate=${endDate}`);
    };

    const handlePerPageChange = (perPage) => {
        history.push(`?page=1&perPage=${perPage}&inspectors=${inspectors}&startDate=${startDate}&endDate=${endDate}`);
    };

    const [inspectorsList, setInspectorsList] = useState([]);
    const [selectedInspectors, setSelectedInspectors] = useState([]);
    const [isLoadingInspectors, setIsLoadingInspectors] = useState(false);


    const extractIds = (list) => {
        return list.reduce((acc, obj) => {
            acc.push(obj.id);
            return acc;
        }, []);
    }


    const searchInspectors = (name) => {
        setIsLoadingInspectors(true);
        const resource = new Resource('user');
        resource.index({name}).then(({data: {data: {data}}}) => {
            setIsLoadingInspectors(false);
            const selectedInspectorIds = extractIds(selectedInspectors);
            const inspectors = data.map((inspector) => {
                return {'title': `${inspector.first_name} ${inspector.last_name}`, 'id': inspector.id};
            }).filter(inspector => !selectedInspectorIds.includes(inspector.id));
            setInspectorsList(inspectors);
        }).catch(() => {
            setIsLoadingInspectors(false);
        });
    };

    const clear = () => {
        setInspectors([]);
        setInspectorsList([]);
        setStartDate(null);
        setEndDate(null);
    }

    const searchResults = () => {
        const inspectors = extractIds(selectedInspectors);
        setInspectors(inspectors);
        setIsLoading(true);
    }

    const download = () => {
        const resource = new Resource('report/flower/inspection/download');
        setIsDownLoading(true);
        resource.index({
            perPage,
            inspectors,
            page,
            startDate,
            endDate,
        })
            .then(response => {
                setIsDownLoading(false);
                setIsDownLoadComplete(true);
                const {data} = response;
                let blob = new Blob([data], {type: "application/octetstream"});
                let a = document.createElement('a');
                a.href = window.URL.createObjectURL(blob);
                a.download = "inspectors-report.xlsx";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(a.href);
                setTimeout(() => {
                    setIsDownLoadComplete(false);
                }, 2000);
            }).catch(err => {
            setIsDownLoading(false);
        });
    };

    return (
        <div className={coreStyle.root}>
            <InputGroup className="mb-3 input-group">
                <AutoComplete label={'Inspector'} handleInputChange={(e, value) => searchInspectors(value)}
                              handleOnChange={(e, inspectors) => setSelectedInspectors(inspectors)}
                              optionsList={inspectorsList}
                              isLoading={isLoadingInspectors}/>
            </InputGroup>

            <InputGroup className="mb-6 input-group mb-2">
                <DatePicker label={'Start Date'} handleDateChange={setStartDate}/>
                <DatePicker label={'End Date'} handleDateChange={setEndDate}/>

                <InputGroup.Append>
                    <Button variant="outline-secondary" onClick={searchResults} disabled={false}>
                        <Translate id="SEARCH.SEARCH"/>
                        <i className="fa fa-search ml-sm-2" style={{"fontSize": ".7rem"}}/>
                    </Button>
                    <Button variant="outline-secondary" className="ml-sm-3" onClick={download} disabled={false}>
                        <Translate id="SEARCH.DOWNLOAD"/>
                        <i className={`fa ${isDownloading ? 'fa-spinner' : (isDownloadComplete ? 'fa-check-circle' : 'fa-download')} ml-sm-2`}
                           style={{"fontSize": ".7rem"}}/>
                    </Button>
                </InputGroup.Append>

                <Button variant="outline-secondary" className="ml-sm-3" onClick={clear} disabled={false}>
                    <Translate id="SEARCH.CLEAR"/>
                    <i className="fa fa-trash ml-sm-2" style={{"fontSize": ".7rem"}}/>
                </Button>
            </InputGroup>
            <Paper className={coreStyle.paper}>
                <TableContainer>
                    <Table
                        className={coreStyle.table}
                        aria-labelledby="tableTitle"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            rowCount={isLoading ? 0 : inspections.length}
                            headCells={headCells}
                            isLoading={isLoading}
                        />
                        <TableBody>
                            {inspections.map(inspection => {

                                inspection.getStatus = () => {
                                    return inspection.active === '1' ? 'active' : 'inactive';
                                };

                                return (
                                    <TableRow
                                        hover
                                        tabIndex={-1}
                                        key={inspection.id}
                                    >
                                        <TableCell>{inspection?.inspector?.first_name} {inspection?.inspector?.last_name}</TableCell>
                                        <TableCell>{inspection?.grower?.name}</TableCell>
                                        <TableCell>{inspection?.order?.buyer?.name}</TableCell>
                                        <TableCell>{inspection?.boxes_inspected}</TableCell>
                                        <TableCell>{inspection?.boxes_delivered}</TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[15, 50, 100]} labelRowsPerPage={<Translate id="TABLE.ROWS_PER_PAGE"/>}
                    component="div"
                    count={pagination.total}
                    rowsPerPage={pagination.per_page}
                    page={pagination.current_page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={(e) => handlePerPageChange(e.target.value)}
                />
            </Paper>
        </div>
    );
}
